import { withRouter, useRouteMatch } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useState, useEffect } from "react";
import axios from "axios";
import { flushCart } from "../redux/cartSlice";
import { Api } from "../provider/firebase";
import Swal from "sweetalert2";
import { calculateOrderPrice, exportLogo, getHostName, parsePrice } from "../provider/functions";

export default withRouter(PayCart);

const styles = {
  pageContainer: {
    minHeight: '100vh',
    background: 'linear-gradient(180deg, #fafafa 0%, #f0f0f0 100%)',
    paddingBottom: 160,
  },
  header: {
    padding: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  backButton: {
    width: 44,
    height: 44,
    borderRadius: 14,
    background: '#fff',
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
    fontSize: 18,
    color: '#333',
  },
  logoContainer: {
    maxHeight: 56,
    borderRadius: 16,
    overflow: 'hidden',
  },
  logo: {
    height: 56,
    width: 'auto',
    objectFit: 'contain',
  },
  stepsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 0,
    padding: '8px 20px 24px',
  },
  formContainer: {
    padding: '0 16px',
  },
  formCard: {
    background: '#fff',
    borderRadius: 20,
    padding: 20,
    marginBottom: 16,
    boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
    border: '1px solid rgba(0,0,0,0.04)',
  },
  sectionTitle: {
    fontSize: 13,
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    marginBottom: 12,
    opacity: 0.7,
    color: '#111',
  },
  inputLabel: {
    fontSize: 14,
    fontWeight: 600,
    marginBottom: 8,
    display: 'block',
    color: '#111',
  },
  input: {
    width: '100%',
    padding: '14px 16px',
    borderRadius: 14,
    border: '1px solid rgba(0,0,0,0.1)',
    fontSize: 15,
    background: 'rgba(0,0,0,0.02)',
    outline: 'none',
    marginBottom: 16,
    boxSizing: 'border-box',
    color: '#111',
  },
  inputError: {
    borderColor: '#e53935',
    background: 'rgba(229, 57, 53, 0.04)',
  },
  inputDisabled: {
    color: '#999',
    background: 'rgba(0,0,0,0.03)',
  },
  select: {
    width: '100%',
    padding: '14px 16px',
    borderRadius: 14,
    border: '1px solid rgba(0,0,0,0.1)',
    fontSize: 15,
    background: 'rgba(0,0,0,0.02)',
    outline: 'none',
    marginBottom: 16,
    cursor: 'pointer',
    appearance: 'none',
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='%23333' viewBox='0 0 16 16'%3E%3Cpath d='M8 11L3 6h10l-5 5z'/%3E%3C/svg%3E")`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right 16px center',
    color: '#111',
  },
  bottomSheet: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    background: '#fff',
    borderRadius: '24px 24px 0 0',
    padding: '20px 20px 28px',
    boxShadow: '0 -4px 30px rgba(0,0,0,0.1)',
    zIndex: 100,
  },
  totalRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: 14,
    borderTop: '1px solid rgba(0,0,0,0.08)',
    marginBottom: 16,
  },
  totalLabel: {
    fontSize: 16,
    fontWeight: 600,
    color: '#111',
  },
  totalValue: {
    fontSize: 22,
    fontWeight: 700,
    color: '#111',
  },
  orderButton: {
    width: '100%',
    height: 56,
    borderRadius: 16,
    border: 'none',
    background: '#000',
    fontFamily: 'inherit',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 8px 0 16px',
    outline: 'none',
    transition: 'opacity 0.15s, box-shadow 0.15s',
    gap: 8,
  },
  orderButtonDisabled: {
    opacity: 0.4,
    cursor: 'not-allowed',
  },
};

function PayCart({ history }) {
  const dispatch = useDispatch();
  let match = useRouteMatch();
  const language = useSelector((state) => state.language.data);
  const [loading, setloading] = useState(false);
  const [adsoyad, setadsoyad] = useState("");
  const [masano, setmasano] = useState(
    (match.params.table === "undefined" || match.params.table === "all") ? "" : match.params.table
  );
  const [ip, setIP] = useState("");
  const serverReducer = useSelector((state) => state.server.data);
  const { bgcolor1 } = serverReducer;
  const tables = useSelector((state) => state.tables.data);
  const cart = useSelector((state) => state.cart.data);
  const currency = serverReducer.currency;
  const toplam = parseFloat(
    parseFloat(cart.map(v => calculateOrderPrice(v)).reduce((a, b) => a + b, 0)).toFixed(2)
  );
  const showTableSelect = (match.params.table === "undefined" || match.params.table === "all") && serverReducer.showtables;

  function siparisGonder() {
    setloading(true);
    Api.post("/siparisGonder", {
      server: match.params.server ? match.params.server : getHostName(),
      cart: cart.map(value => ({ ...value, note: value.note + " -" + adsoyad })),
      name: adsoyad ?? masano,
      table: masano,
    }).then((res) => {
      if (res.data.error || !(res.data.success || res.data === true)) {
        if (res.data?.error === "recaptcha-error") {
          return Swal.fire("Recaptcha!", language.recaptcha, "error");
        } if (res.data?.error === "server-not-found") {
          return Swal.fire("Hata!", language.restorant_not_found, "error");
        } else if (res.data?.error === "cart-not-found") {
          history.goBack();
          return Swal.fire("Hata!", language.sepette_urun_yok, "error");
        } else if (res.data?.error === "name-not-found") {
          return Swal.fire("Hata!", language.ad_zorunlu, "error");
        } else if (res.data?.error === "table-not-found") {
          return Swal.fire("Hata!", language.masa_zorunlu, "error");
        } else if (res.data.message) {
          return Swal.fire("Hata!", res.data.message, "error");
        } else {
          return Swal.fire("Hata!", JSON.stringify(res.data), "error");
        }
      }
      if (res.data.success || res.data === true) {
        history.push((match.params.server ? "/" + match.params.server : "") + "/" + match.params.table + "/categories");
        dispatch(flushCart());
        return Swal.fire(language.basarili, language.siparis_iletildi, "success");
      }
    })
      .catch(() => Swal.fire(language.hata, language.baglanti_hatasi, "error"))
      .finally(() => setloading(false));
  }

  useEffect(() => {
    async function getIp() {
      try {
        const res = await axios.get('https://api64.ipify.org?format=json');
        setIP(res.data.ip);
      } catch {}
    }
    getIp();
  }, []);

  return (
    <div style={styles.pageContainer}>
      {/* Header */}
      <div style={styles.header}>
        <button style={styles.backButton} onClick={history.goBack}>
          <i className="fa fa-arrow-left" />
        </button>
        <div style={{ ...styles.logoContainer, background: '#fafafa' }}>
          <img
            style={styles.logo}
            src={serverReducer.image ? serverReducer.image : "../" + exportLogo(serverReducer.host)}
            alt="Logo"
          />
        </div>
        <div style={{ width: 44 }} />
      </div>

      {/* Steps */}
      <div style={styles.stepsContainer}>
        {/* Step 1 - Menu */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1 }}>
          <div style={{
            width: 36, height: 36, borderRadius: '50%',
            background: 'rgba(76, 175, 80, 0.15)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            marginBottom: 6,
          }}>
            <i className="fa fa-check" style={{ color: '#4CAF50', fontSize: 14 }}></i>
          </div>
          <span style={{ fontSize: 11, fontWeight: 500, color: '#111', opacity: 0.6 }}>{language.menu}</span>
        </div>

        <div style={{ flex: 0.5, height: 3, background: '#4CAF50', borderRadius: 2, marginBottom: 22 }}></div>

        {/* Step 2 - Sepet */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1 }}>
          <div style={{
            width: 36, height: 36, borderRadius: '50%',
            background: 'rgba(76, 175, 80, 0.15)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            marginBottom: 6,
          }}>
            <i className="fa fa-check" style={{ color: '#4CAF50', fontSize: 14 }}></i>
          </div>
          <span style={{ fontSize: 11, fontWeight: 500, color: '#111', opacity: 0.6 }}>{language.sepet}</span>
        </div>

        <div style={{ flex: 0.5, height: 3, background: '#e74c3c', borderRadius: 2, marginBottom: 22 }}></div>

        {/* Step 3 - Sipariş (Active) */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1 }}>
          <div style={{
            width: 40, height: 40, borderRadius: '50%',
            background: '#e74c3c',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            marginBottom: 6,
            boxShadow: `0 4px 14px ${'#e74c3c'}40`,
          }}>
            <span style={{ color: '#fff', fontSize: 14, fontWeight: 700 }}>3</span>
          </div>
          <span style={{ fontSize: 11, fontWeight: 600, color: '#111' }}>{language.siparis_ver}</span>
        </div>
      </div>

      {/* Form */}
      <div style={styles.formContainer}>
        {/* Kişisel Bilgiler */}
        <div style={styles.formCard}>
          <div style={styles.sectionTitle}>
            <i className="fa fa-user" style={{ marginRight: 8 }}></i>
            {language.kisisel_bilgiler || "Kişisel Bilgiler"}
          </div>
          <label style={styles.inputLabel}>{language.ad}</label>
          <input
            style={{ ...styles.input, ...(adsoyad.length < 1 ? styles.inputError : {}) }}
            placeholder="Joe Doe"
            value={adsoyad}
            onChange={(e) => setadsoyad(e.target.value)}
          />
        </div>

        {/* Masa Seçimi */}
        {showTableSelect && (
          <div style={styles.formCard}>
            <div style={styles.sectionTitle}>
              <i className="fa fa-chair" style={{ marginRight: 8 }}></i>
              {language.masa_oda}
            </div>
            <label style={styles.inputLabel}>{language.masa_oda}</label>
            <select
              style={{ ...styles.select, ...(masano.length < 1 ? styles.inputError : {}) }}
              onChange={(e) => e.target.value && setmasano(e.target.value)}
            >
              <option value="">{language.selectbox_sec}</option>
              {[...tables].sort((a, b) => String(a).localeCompare(String(b), undefined, { numeric: true })).map((v, i) => <option key={i} value={v}>{v}</option>)}
            </select>
          </div>
        )}

        {/* IP Adresi */}
        <div style={styles.formCard}>
          <div style={styles.sectionTitle}>
            <i className="fa fa-network-wired" style={{ marginRight: 8 }}></i>
            {language.ip_adres}
          </div>
          <input
            style={{ ...styles.input, ...styles.inputDisabled, marginBottom: 0 }}
            value={ip}
            disabled
          />
        </div>
      </div>

      {/* Bottom Sheet */}
      <div style={styles.bottomSheet}>
        <button
          style={{
            ...styles.orderButton,
            background:  '#e74c3c',
            boxShadow: `0 6px 28px ${'#e74c3c'}60`,
            ...(loading || !adsoyad ? styles.orderButtonDisabled : {}),
          }}
          disabled={loading || !adsoyad}
          onClick={siparisGonder}
        >
          {loading ? (
            <div className="spinner-border spinner-border-sm text-light" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          ) : (
            <>
              <div style={{display:'flex',alignItems:'center',gap:8,flexShrink:0}}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <line x1="3" y1="6" x2="21" y2="6" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
                  <path d="M16 10a4 4 0 01-8 0" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span style={{fontSize:15,fontWeight:800,letterSpacing:'-0.3px',color:'#fff',whiteSpace:'nowrap'}}>{language.siparis_ver}</span>
              </div>
              <span style={{background:'rgba(255,255,255,0.2)',color:'#fff',borderRadius:10,padding:'7px 14px',fontSize:11,fontWeight:800,letterSpacing:'-0.2px',whiteSpace:'nowrap',lineHeight:1,flexShrink:0}}>
                {parsePrice(toplam)} {currency}
              </span>
            </>
          )}
        </button>
      </div>
    </div>
  );
}
